import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DoctorsModel } from '../models/DoctorsModel';
import { URLsConfig } from '../URLsConfig';
import { DoctorFeeModel } from '../models/DoctorFeeModel';

@Injectable()
export class DoctorsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getdoctors(docCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("docCode", docCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<DoctorsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/GetDoctors',options);
    }
    public Adddoctors(doctors: DoctorsModel) {
        
        return this.http.post<DoctorsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/AddDoctors', doctors);
    }
    public delDoctors(docCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("docCode", docCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<DoctorsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/Deletedoctors',options);
    }
    public getDoctorsLookup(docCode: string, docName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("docCode", docCode);
      params = params.append("docName", docName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<DoctorsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/DoctorsLookup', options);
  }

    public getDoctorsLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<DoctorsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/DoctorsLookupTop', options);
  }

  public getDoctorsLookupTopDep(compCode: string,docDepartment: string) {
    let params = new HttpParams();
    params = params.append("docDepartment", docDepartment);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<DoctorsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/DoctorsLookupTopDep', options);
}
//////-------------- Doctor Fee ---------------------------------
  public getdoctorsFee(docCode: string ) {
      let params = new HttpParams();
        params = params.append("docCode", docCode);
   
        const options = {
            params: params
        };
        return this.http.get<DoctorFeeModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/GetDoctorsFee',options);
    }
  public AdddoctorsFee(doctorsfee: DoctorFeeModel) {
        
        return this.http.post<DoctorFeeModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/AddDoctorsFee', doctorsfee);
    }

  public DelDoctorsFee(docCode: string ) {

      let params = new HttpParams();
        params = params.append("docCode", docCode);
    
        const options = {
          params: params
      };
      return this.http.get<DoctorFeeModel>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/DeletedoctorsFee',options);
    }
    ////DoctorsInvoiceLookupTop
    public getDoctorsInvoiceLookupTop(patientcode: string) {
      let params = new HttpParams();
      params = params.append("patientcode", patientcode);
      const options = {
          params: params
      };
      return this.http.get<DoctorsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Doctors/DoctorsInvoiceLookupTop', options);
  }
}
